import * as _4 from 'lodash4';
import { INotificationDelegate } from '../global/helpers/notification_delegate';
import { ApAdvisorChangelogRoutes } from '../routes/advisor_routes/ap_advisor_changelog_routes';
import { ApAdvisorCourseDetailRoutes } from '../routes/advisor_routes/ap_advisor_course_detail_routes';
import { ApPlanAdvisorRoutes } from '../routes/advisor_routes/ap_advisor_plan_routes';
import { AdvisorPreviewPlanRoutes } from '../routes/advisor_routes/ap_advisor_preview_plan_routes';
import { AlternatePlanRoutes } from '../routes/ap_alternate_plan_routes';
import { ApChangelogRoutes } from '../routes/ap_changelog_routes';
import { ApModelRoutes, MultiApModelRoutes } from '../routes/ap_course_details_routes';
import { ApDefaultRootRoutes } from '../routes/ap_default_root_routes';
import { ApPlanFeedbackRoutes } from '../routes/ap_plan_feedback_routes';
import { APMultiPlanRoutes, ApPlanRoutes } from '../routes/ap_plan_routes';
import { ApPreviewPlanRoutes } from '../routes/ap_preview_plan_routes';

const planDefaultRoute = '/my/planner/plan/default/';
class ApStateProvider implements ng.IServiceProvider {
  constructor(private $stateProvider: ng.ui.IStateProvider, private $urlRouterProvider: ng.ui.IUrlRouterProvider) {}

  private setDefaultUrlStates() {
    this.$urlRouterProvider.when('/my/planner/', '/my/planner/map/');
    this.$urlRouterProvider.when('/my/planner/map', planDefaultRoute);
    this.$urlRouterProvider.when('/my/planner/plan/map', planDefaultRoute);
    this.$urlRouterProvider.when('/my/planner/plan/favorite', planDefaultRoute);
    this.$urlRouterProvider.when('/my/planner/plan/search', planDefaultRoute);
    this.$urlRouterProvider.when('/advisor/student/plan', '/advisor/student/plan/default');
  }

  private getStates() {
    return {
      ...ApDefaultRootRoutes,
      ...ApPlanRoutes,
      ...APMultiPlanRoutes,
      ...ApPlanAdvisorRoutes,
      ...ApPreviewPlanRoutes,
      ...ApPlanFeedbackRoutes,
      ...ApAdvisorCourseDetailRoutes,
      ...AdvisorPreviewPlanRoutes,
      ...ApModelRoutes,
      ...MultiApModelRoutes,
      ...ApChangelogRoutes,
      ...AlternatePlanRoutes,
      ...ApAdvisorChangelogRoutes
    };
  }

  state() {
    this.setDefaultUrlStates();
    const existingStates = this.getStates();
    _4.forOwn(existingStates, (value: ng.ui.IState, key: string) => this.$stateProvider.state(key, value));
  }

  $get = () => ({});
}

angular
  .module('capability-ng-academic-planner')
  .provider('academicPlannerStateConfiguration', ApStateProvider)
  .run(($rootScope: ng.IRootScopeService, $state: ng.ui.IStateService, $injector: any) => {
    const stateChangeNotificationName = 'STATE-TRANSITION-NOTIFICATION';
    $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, rejection) => {
      $injector.get('ngAPNotificationDelegate').dismissAlertByName(stateChangeNotificationName);
      if (_4.isFunction(toState.onErrorState)) {
        const errorStateToGo = toState.onErrorState(event, toState, toParams, fromState, fromParams, rejection);
        $state.go(errorStateToGo);
      }
    });
    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
      $injector.get('ngAPNotificationDelegate').info({
        content: `<span l-no-wrap l-kind="hort" l-align="center" l-width-fixed><hi-indicator theme="white" size='small' class="mrm display-block" l-size="grow"></hi-indicator>Loading ${_4.get(
          toState.data,
          'pageTitle',
          '...'
        )}</span>`,
        name: stateChangeNotificationName
      });
    });
    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
      $injector.get('ngAPNotificationDelegate').dismissAlertByName(stateChangeNotificationName);
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/config/academic_planner_config.ts